import styled from 'styled-components';
import { SessionController } from './session.controller';
import { sharedResolution } from './shared_resolution';

const Error = styled.div`
	color: white;
	position: relative;
	z-index: 0;

	&::after {
		content: '';
		position: absolute;
		margin: -5px;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		border: 2px solid #790000;
		background: #ff7a7a;
		z-index: -1;
	}
`;

interface Translations {
	'start-session.button-next': string;
	'start-session.title': string;
	'start-session.description-flow-0': string;
	'start-session.description-flow-1': string;
	'start-session.input-name': string;
	'start-session.input-name-invalid': string;
	'start-session.button-next-error': string;
	'error-404.title': string;
	'error-404.description': string;
	'error-404.button-back': string;
	'thank-you.title': string;
	'thank-you.description': string;
	'thank-you.button-back': string;
	'qr-hook.title': string;
	'qr-hook.description': string;
}

const translations_en: Translations = {
	'start-session.button-next': 'Next',
	'start-session.title': 'Start triage',
	'start-session.description-flow-0':
		'Please enter your name and start your session. The results of your session will be available at the healthcare provider station',
	'start-session.description-flow-1': 'Please enter your name and start your session.',
	'start-session.input-name': 'Name',
	'start-session.input-name-invalid': 'Please enter your name to proceed',
	'start-session.button-next-error': 'Something went wrong, please try again',
	'error-404.title': 'Page not found',
	'error-404.description': 'The page you are looking for does not exist',
	'error-404.button-back': 'To start page',
	'thank-you.title': 'Thank you!',
	'thank-you.description':
		'Thank you for trying out Visiba Triage, the results of your sessions are now available at the healthcare provider station',
	'thank-you.button-back': 'Test again',
	'qr-hook.title': 'Scan me!',
	'qr-hook.description': 'To try out Visiba Triage, scan the QR code with your phone',
};

const translations_no: Translations = {
	'start-session.button-next': 'Neste',
	'start-session.title': 'Start triage',
	'start-session.description-flow-0':
		'Skriv inn navnet ditt og start triagen. Resultatene fra triagen vil være tilgjengelig for helsepersonell i deres Visiba Care grensesnitt.',
	'start-session.description-flow-1': 'Skriv inn navnet ditt og start triagen.',
	'start-session.input-name': 'Navn',
	'start-session.input-name-invalid': 'Vennligst skriv inn navnet ditt for å fortsette',
	'start-session.button-next-error': 'Noe gikk galt, vennligst prøv igjen',
	'error-404.title': 'Siden ble ikke funnet',
	'error-404.description': 'Siden du leter etter eksisterer ikke',
	'error-404.button-back': 'Til startside',
	'thank-you.title': 'Takk!',
	'thank-you.description':
		'Takk for at du prøvde Visiba Triage, resultatene av sesjonene dine er nå tilgjengelige på helsepersonellens stasjon',
	'thank-you.button-back': 'Test igjen',
	'qr-hook.title': 'Skann meg!',
	'qr-hook.description': 'For å prøve Visiba Triage, skann QR-koden med telefonen din',
};

const translations_sv: Translations = {
	'start-session.button-next': 'Nästa',
	'start-session.title': 'Starta triage',
	'start-session.description-flow-0':
		'Skriv in ditt namn och starta triagen. Resultaten från triagen kommer att vara tillgängliga för vårdpersonal i deras Visiba Care-gränssnitt.',
	'start-session.description-flow-1': 'Skriv in ditt namn och starta triagen.',
	'start-session.input-name': 'Namn',
	'start-session.input-name-invalid': 'Vänligen skriv in ditt namn för att fortsätta',
	'start-session.button-next-error': 'Något gick fel, vänligen försök igen',
	'error-404.title': 'Sidan hittades inte',
	'error-404.description': 'Sidan du letar efter existerar inte',
	'error-404.button-back': 'Till startsida',
	'thank-you.title': 'Tack!',
	'thank-you.description':
		'Tack för att du provade Visiba Triage, resultaten av dina sessioner är nu tillgängliga för vårdpersonalens station',
	'thank-you.button-back': 'Testa igen',
	'qr-hook.title': 'Skanna mig!',
	'qr-hook.description': 'För att prova Visiba Triage, skanna QR-koden med din telefon',
};

export const withTranslation = (key: keyof Translations): string => {
	const controller = sharedResolution.resolve(SessionController);

	let translations = translations_en;

	if (controller.languageCode === 'sv') {
		translations = translations_sv;
	} else if (controller.languageCode === 'no') {
		translations = translations_no;
	}

	const translation = translations[key];
	if (translation !== '') return translation;

	return (<Error>{key}</Error>) as unknown as string;
};
